import { Component, OnInit, Input, HostListener } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../../_layouts/layoutService';
import { SwitchLanguageComponent } from '../../_modals/switch-language/switch-language.component';
import { AuthenticationService, DialogService } from '../../_services';
import { AppConfigService } from '../../_services/appConfigService';
import { AppDialogsService } from '../../_services/appDialogsService';
import { AppThemeService } from '../../_services/appThemeService';
import { RouteNavigationService } from '../../_services/routeNavigationService';
import { SearchbarService } from '../../_services/searchbar.service';
import { AppFiltersModalComponent } from '../app-filters-modal/app-filters-modal.component';
import { AppFiltersComponent, CustomDateParserFormatter } from '../app-filters/app-filters.component';
import { StorageService } from '../../_services/storage.service';
import { CommonService } from '../../_services/common.service';
import { StringConstants } from '../../_constants/stringConstants';
import { CommonDataService } from '../../appDataServices/commonDataService';
import { OfflineService } from '../../_services/offlineService';
import { Config } from '../../_store';

@Component({
  selector: 'app-header-toolbar',
  templateUrl: './app-header-toolbar.component.html'
})
export class AppHeaderToolbarComponent implements OnInit {
  @Input() showMenuButton = false;
  @Input() showBackButton = true;
  @Input() hideToolbar;
  isCondensed = false;
  userName = '9 Corps Zonal Workshop';
  currencies= [
    'INR' ,
    'USD' ,
    'EUR' ,
    'HKD' ,
    'AUD' ,
    'CAD' ,
    'MXN' ,
    'CNY' ,
    'JPY' ,
    'PLN' ,
    'TRY' ,
    'MYR' ,
  ]

  logo = 'payex.png';
  logo_sm = 'payex.png';
  currentCurrency: any;

  constructor(
    private authService: AuthenticationService,
    private popoverController: PopoverController,
    public appThemeService: AppThemeService,
    private layoutService: LayoutService,
    private appDialogsService: AppDialogsService,
    private translate: TranslateService,
    private dialogService: DialogService,
    private routeNavigationService: RouteNavigationService,
    private searchbarService: SearchbarService,
    private storageService: StorageService,
    private commonDataService: CommonDataService,
    private commonService: CommonService,
    private offlineService: OfflineService,
  ) { }

  ngOnInit() {
    this.isCondensed = this.layoutService.getIsCondensed();
    this.initLanguage();
    this.storageService.get(StringConstants.CURRENT_CURRENCY).then(curr => {
      if (curr !== null && curr !== undefined && curr !== '') {
        this.currentCurrency = curr;
      } else {
          // Default to application configured currency
          this.currentCurrency = Config.defaultCurr;
      }
    })
  }

  async showSwichLanguagePopover(ev: any) {
    const popover = await this.popoverController.create({
      component: SwitchLanguageComponent,
      event: ev,
      translucent: true,

    });
    await popover.present();

    const { role } = await popover.onDidDismiss();
  }

  onToggleMobileMenu($event) {
    this.layoutService.toggleSidebar();
    this.isCondensed = this.layoutService.getIsCondensed();
    const show = (this.searchbarService.getSearchBar()) ? false : false;
    this.searchbarService.setSearchBar(show);
  }

  logout() {
    this.dialogService.showConfirmDialog({
      // cssCls: 'customDialog',
      //header: this.translate.instant('MESSAGES.CONFIRM_LOGOUT_QUESTION'),
      //header: this.translate.instant('MESSAGES.PLEASE_CONFIRM'),
      header: this.translate.instant('MESSAGES.PLEASE_CONFIRM'),
      message: this.translate.instant('MESSAGES.CONFIRM_LOGOUT_QUESTION'),
      // ok: this.translate.instant('LABELS.YES_LOG_ME_OUT'),
      ok: this.translate.instant('LABELS.YES,_LOG_ME_OUT'),
      cancel: this.translate.instant('LABELS.CANCEL')

    }).then((res) => {
      if (res) {
        this.authService.logout();
        this.routeNavigationService.navigateRoot('/signin');
      }
    });
  }


  //Moving language switch code here, this is duplicate of what we have in switch-language component
  currentLanguage = 'en';
  selectedLanguage = {
    shortCode: this.currentLanguage,
    icon: 'assets/images/flags/us.jpg'
  };
  languages = [];
  initLanguage() {
    this.storageService.get(StringConstants.CURRENT_Language).then((lang) => {
      if (lang) {
        this.currentLanguage = lang;
        this.initSelectedLanguage();
      }
    });
    this.getSupportedLanguages();
    this.initSelectedLanguage();
  }

  onLanguageSwitch(language: string) {
    this.currentLanguage = language;
    this.storageService.add(StringConstants.CURRENT_Language, language).then(res => {
    this.translate.setDefaultLang(language);
    this.translate.use(language);
    });
    this.initSelectedLanguage();
  }

  onCurrencySwitch(currency: string) {
    this.storageService.add(StringConstants.CURRENT_CURRENCY, currency).then(res => {
      this.offlineService.reInitializeOfflineDocuments();
      window.location.reload()
    })

  }

  getSupportedLanguages() {
    this.commonService.getSupportedLanguages().then((languages: any[]) => {
      if (Array.isArray(languages) && languages.length > 0) {
        this.languages = languages;
      } else {
        this.commonDataService.getSupportedLanguages().subscribe(langs => {
          if (langs !== null && langs !== undefined) {
            this.languages = langs;
            this.commonService.storeSupportedLanguages(langs);
          }
        });
      }
      this.initSelectedLanguage();
    });
  }

  initSelectedLanguage() {
    if (this.languages.length && this.currentLanguage) {
      const selectedLang = this.languages.find(lang => lang.ShortCode === this.currentLanguage);
      if (selectedLang) {
        this.selectedLanguage.icon = selectedLang.icon;
        this.selectedLanguage.shortCode = this.currentLanguage;
      }
    }
  }



}

